/* Nhập mã lớp 4 chữ số (mentor gửi) để vào đúng lớp. Dùng ở Khóa học của tôi và trang xem khoá. */
import { useState, type FormEvent } from "react"
import { Button } from "@/components/ui/button"
import { InputGroup, InputGroupAddon, InputGroupInput } from "@/components/ui/input-group"
import { Label } from "@/components/ui/label"
import { Icon } from "@/components/icon"
import { loginUrl, post } from "@/lib/api"
import { cn } from "@/lib/utils"

export function CourseCodeForm({ user, courseName, compact = false, className }: { user: any; courseName?: string; compact?: boolean; className?: string }) {
  const [code, setCode] = useState(() => localStorage.getItem("simba-course-code") || "")
  const [error, setError] = useState("")
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setError("")
    const normalized = code.replace(/\D/g, "").slice(0, 4)
    setCode(normalized)
    if (normalized.length !== 4) return setError("Mã cần có đúng 4 chữ số.")
    localStorage.setItem("simba-course-code", normalized)
    if (!user) {
      location.href = loginUrl()
      return
    }
    setBusy(true)
    try {
      const data = await post("/api/course-code", { code: normalized })
      localStorage.removeItem("simba-course-code")
      location.href = data.destination
    } catch (err: any) {
      if (err.status === 401) {
        location.href = loginUrl()
        return
      }
      setError(err.message)
      setBusy(false)
    }
  }

  return (
    <form onSubmit={submit} className={cn("flex flex-col gap-3", className)}>
      <div className="flex flex-col gap-1">
        <Label htmlFor="course-code" className="font-heading text-base font-semibold text-ink">
          {compact ? "Mã lớp" : "Course Code"}
        </Label>
        {!compact && (
          <p className="text-sm text-muted-foreground">
            {courseName ? `Nhập mã mentor gửi để bắt đầu học ${courseName}.` : "Nhập mã 4 chữ số mentor gửi để vào đúng lớp."}
          </p>
        )}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <InputGroup className="sm:max-w-48">
          <InputGroupAddon>
            <Icon name="lock" className="size-4" />
          </InputGroupAddon>
          <InputGroupInput
            id="course-code"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]{4}"
            maxLength={4}
            placeholder="••••"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 4))}
            aria-invalid={!!error}
            aria-describedby={error ? "code-error" : undefined}
            aria-label="Mã lớp gồm 4 chữ số"
            className="font-heading text-lg tracking-[0.4em]"
          />
        </InputGroup>
        <Button type="submit" disabled={busy}>
          {busy ? "Đang mở…" : compact ? "Mở lớp" : user ? "Vào lớp" : "Đăng nhập & vào lớp"}
          <Icon name="arrow-right" className="size-4" />
        </Button>
      </div>
      {error && (
        <p id="code-error" role="alert" className="text-sm text-danger">
          {error}
        </p>
      )}
    </form>
  )
}
